<template>
  <section class="campanhas">
    <v-form data-app>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            Selecione data de início e fim da campanha
          </v-card-title>
          <v-card-text>
            <v-date-picker
              header-color="primary"
              color="green lighten-1"
              v-model="intervaloCampanha"
              range
            ></v-date-picker>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#005A64"
              dark
              style="font-size: 0.938rem"
              @click="dialog = false"
              >Fechar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-container>
        <h3 class="campanhas__title">Configurar regras da campanha</h3>
        <v-row>
          <v-col cols="12" md="3">
            <label for="" class="campanhas__label">Nome da campanha</label>
            <v-text-field
              v-model="descricao"
              :counter="15"
              :rules="nomeCampanha"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <label for="" class="campanhas__label">Usuário</label>
            <v-text-field v-model="usuario" disabled required></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <label for="" class="campanhas__label">Intervalo da campanha</label>
            <v-text-field
              @click="dialog = true"
              v-model="dateRangeText"
              :rules="campoObrigatorio"
              prepend-icon="mdi-calendar"
              readonly
            ></v-text-field>
          </v-col>
					<v-col cols="12" md="3">
            <label for="" class="campanhas__label">Canal de Vendas</label>
            <v-select
              v-model="canalSelecionado"
              :items="canais"
              item-text="valor"
              item-value="valor"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="2">
            <label for="" class="campanhas__label">Multiplicador</label>
            <v-text-field
              v-model="multiplicador"
              placeholder="Ex: 1"
              :rules="campoObrigatorio"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <label for="" class="campanhas__label">Valor Fixo</label>
            <v-text-field
              v-model="valorFixo"
              placeholder="Ex: 1"
              :rules="campoObrigatorio"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <label for="" class="campanhas__label">Marcas</label>
            <v-select
              v-model="marcaSelecionada"
              @change="atualizaRegra"
              :items="marcas"
              item-text="valor"
              item-value="valor"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <label for="" class="campanhas__label">Categorias</label>
            <v-select
              v-model="categoriaSelecionada"
              :items="categorias"
              item-text="valor"
              item-value="valor"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <label for="" class="campanhas__label">Capacidade</label>
            <v-select
              v-model="capacidadeSelecionada"
              :items="capacidade"
              item-text="valor"
              item-value="valor"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <label for="" class="campanhas__label">SKU</label>
            <v-text-field
              v-model="skuSelecionado"
              @change="atualizaRegra"
              hint="Para mais de um SKU separe com um espaço!"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="2">
            <v-btn @click="addRegra" class="ma-2" dark color="#005A64">
              Adicionar
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <div
      class="regrasSelecionadas"
      style="overflow-x: auto"
      v-if="regraSelecionada.length > 0"
    >
      <h3 class="regrasSelecionadas__title">Regras selecionadas</h3>

      <table>
        <thead>
          <tr>
            <th>Multiplicador</th>
            <th>Valor Fixo</th>
            <th>Marca</th>
            <th>Categoria</th>
            <th>Capacidade</th>
            <th>SKU</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(regras, i) in regraSelecionada" :key="i">
            <td>{{ regras.multiplicador }}</td>
            <td>{{ regras.valorFixo }}</td>
            <td>{{ regras.marca }}</td>
            <td>{{ regras.categoria }}</td>
            <td>{{ regras.capacidade }}</td>
            <td>{{ regras.sku }}</td>
          </tr>
        </tbody>
      </table>
      <v-btn @click="salvarCampanha" class="ma-2" dark color="#005A64">
        Salvar Campanha
      </v-btn>
    </div>

    <div class="campanhasSalvas" style="overflow-x: auto">
      <h3 class="campanhasSalvas__title">Campanhas Salvas</h3>

      <div class="campanhasSalvas__search">
        <input
          id="inputSearch"
          @keyup="buscarCampanha"
          type="search"
          placeholder="Pesquisar pelo nome da campanha"
        />
      </div>
      <table id="table">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Usuário</th>
						<th>Canal</th>
            <th>Multiplicador</th>
            <th>Valor Fixo</th>
            <th>Data Inicial</th>
            <th>Data Final</th>
            <th>Marca</th>
            <th>Categoria</th>
            <th>Capacidade</th>
            <th>SKU</th>
            <th>Editar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(props, i) in result" :key="i" id="i">
            <td>{{ props.descricao }}</td>
            <td>{{ props.usuario }}</td>
						<td>{{ props.canal }}</td>
            <td>{{ props.multiplicador | toCurrency }}</td>
            <td>{{ props.valorFixo | toCurrency }}</td>
            <td>{{ props.dtInicio }}</td>
            <td>{{ props.dtFim }}</td>
            <td>{{ props.marca }}</td>
            <td>{{ props.categoria }}</td>
            <td>{{ props.btus }}</td>
            <td>{{ props.sku }}</td>
            <td><button @click="encerrar(props.id)">Encerrar</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      intervaloCampanha: ["", ""],
      dtInicio: null,
      regraSelecionada: [],
			canalSelecionado: null,
			canais: [],
      dtFim: null,
      skuSelecionado: null,
      bIntervalo: false,
      usuario: null,
      multiplicador: null,
      valorFixo: null,
      marcaSelecionada: null,
      categoriaSelecionada: null,
      capacidadeSelecionada: null,
      descricao: null,
      dialog: false,
      dialogFile: false,
      confirmDialog: false,
      contentFile: null,
      showAlert: false,
      showMessageSuccess: false,
      textAlert: "",
      titleAlert: "",
      parameter: {},
      isEdit: false,
      orcamento: null,
      pendenteFinalizacao: null,
      pendentePagamento: null,
      analiseRisco: null,
      parcialmenteAprovado: null,
      pendenteERP: null,
      token: null,
      result: [],
      marcas: [],
      capacidade: [],
      categorias: [],
      search: "",
      regraSelecionadaHeader: [
        {
          text: "Multiplicador",
          align: "left",
          sortable: false,
          value: "multiplicador",
        },
        {
          text: "Valor Fixo",
          align: "left",
          value: "valorFixo",
        },
        {
          text: "Marca",
          align: "left",
          sortable: false,
          value: "marca",
        },
        {
          text: "Categoria",
          align: "left",
          sortable: false,
          value: "categoria",
        },
        {
          text: "Capacidade",
          align: "left",
          sortable: false,
          value: "capacidade",
        },
        {
          text: "Sku",
          align: "left",
          sortable: false,
          value: "sku",
        },
      ],
      headers: [
        {
          text: "Nome",
          align: "center",
          sortable: false,
          value: "descricao",
        },
        {
          text: "Usuário",
          align: "center",
          sortable: false,
          value: "usuario",
        },
        {
          text: "Início",
          align: "center",
          sortable: false,
          value: "dtInicio",
        },
        {
          text: "Fim",
          align: "center",
          sortable: false,
          value: "dtFim",
        },
        {
          text: "Multiplicador",
          align: "center",
          sortable: false,
          value: "multiplicador",
        },
        {
          text: "Valor Fixo",
          align: "center",
          value: "valorFixo",
        },
        {
          text: "Marca",
          align: "center",
          sortable: false,
          value: "marca",
        },
        {
          text: "Categoria",
          align: "center",
          sortable: false,
          value: "categoria",
        },
        {
          text: "Btus",
          align: "center",
          sortable: false,
          value: "btus",
        },
        {
          text: "Sku",
          align: "center",
          sortable: false,
          value: "sku",
        },
        {
          text: "",
          align: "center",
          sortable: false,
        },
      ],
      nomeCampanha: [
        (v) => !!v || "Nome da campanha é obrigatório",
        (v) =>
          v.length <= 15 ||
          "Nome da campanha não pode ser maior que 15 caracteres",
      ],
      campoObrigatorio: [(v) => !!v || "Campo obrigatório!"],
      parameterSelected: null,
      pagination: {
        sortBy: "uf",
      },
    };
  },
  computed: {
    dateRangeText() {
      return this.intervaloCampanha.join(" à ");
    },
  },

  async created() {
    let dados = JSON.parse(localStorage.getItem("login"));
    this.usuario = dados.nomeUsuarioLogado;
  },
  methods: {
		async encerrar(id){
			// alert(id)
			await axios.put(`https://pricing-api.leverosservicos.com.br/campanhas/delete/${id}`);
			this.montaDropDowns();
		},
    buscarCampanha() {
      let input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("inputSearch");
      filter = input.value;
      table = document.getElementById("table");
      tr = table.getElementsByTagName("tr");
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[0];

        if (td) {
          txtValue = td.textContent || td.innerText;
          if (txtValue.indexOf(filter) > -1) {
            tr[i].style.display = "";
          } else {
            tr[i].style.display = "none";
          }
        }
      }
    },
    async salvarCampanha() {
      let dadosCampanha = {
        descricao: this.descricao,
        usuario: this.usuario,
        dtInicio: this.intervaloCampanha[0] + "T03:00:00.0000Z",
        dtFim: this.intervaloCampanha[1] + "T23:59:59.0000Z",
				canal: this.canalSelecionado.valor,
        regras: [],
      };
      for (let i = 0; i < this.regraSelecionada.length; i++) {
        let regra = {
          multiplicador: this.regraSelecionada[i].multiplicador,
          valorFixo: this.regraSelecionada[i].valorFixo,
          marca: this.regraSelecionada[i].marca,
          categoria: this.regraSelecionada[i].categoria,
          btus: this.regraSelecionada[i].capacidade,
          sku: this.regraSelecionada[i].sku,
        };
        dadosCampanha.regras.push(regra);
      }

      let criar = await axios({
        method: "post",
        url: `https://pricing-api.leverosservicos.com.br/campanhas/insert`,
        data: dadosCampanha,
      });
      if (criar.status == 200) {
        alert("Campanha criada com sucesso");
      } else {
        alert(criar);
      }
    },
    addRegra() {
      if (this.descricao == null || this.descricao == "") {
        alert("Nome da campanha é obrigatório");
      } else if (
        this.intervaloCampanha[0] == "" ||
        this.intervaloCampanha[0] == null
      ) {
        alert("Intervalo da campanha é obrigatório");
      } else if (this.multiplicador != null && this.multiplicador != "") {
        let capacidadeSelecionada = "";
        let marcaSelecionada = "";
        let categoriaSelecionada = "";
        let skuSelecionado = "";
        if (this.capacidadeSelecionada != null) {
          capacidadeSelecionada = this.capacidadeSelecionada.valor;
        }
        if (this.marcaSelecionada != null) {
          marcaSelecionada = this.marcaSelecionada.valor;
        }
        if (this.categoriaSelecionada != null) {
          categoriaSelecionada = this.categoriaSelecionada.valor;
        }
        if (this.skuSelecionado != null) {
          skuSelecionado = this.skuSelecionado;
        }
        let skus = skuSelecionado.split(' ');
        for(let i = 0; i < skus.length; i++) {
          let regra = {
            multiplicador: this.multiplicador.replace(",", "."),
            valorFixo: this.valorFixo.replace(",", "."),
            marca: marcaSelecionada,
            categoria: categoriaSelecionada,
            capacidade: capacidadeSelecionada,
            sku: skus[i],
            canal: this.canalSelecionado
          };
          this.regraSelecionada.push(regra);
        }
        this.multiplicador = null;
        this.valorFixo = null;
        this.marcaSelecionada = null;
        this.categoriaSelecionada = null;
        this.capacidadeSelecionada = null;
        this.skuSelecionado = null;
      } else {
        alert("Campo multiplicador é obrigatório");
        this.montaDropDowns();
      }
    },
    async atualizaRegra() {
      try {
        if (this.skuSelecionado != null && this.skuSelecionado != "") {
          this.marcaSelecionada = null;
          this.categoriaSelecionada = null;
          this.capacidadeSelecionada = null;
          axios
            .get(
              `https://www.leverosintegra.com.br/map/api/GetItemData/${this.skuSelecionado}`
            )
            .then((res) => {
              alert(res.data.ProductName);
            });
        } else {
          let capacidadeSelecionada = "";
          let marcaSelecionada = "";
          let categoriaSelecionada = "";
          if (this.capacidadeSelecionada != null) {
            capacidadeSelecionada = this.capacidadeSelecionada.valor;
          }
          if (this.marcaSelecionada != null) {
            marcaSelecionada = this.marcaSelecionada.valor;
          }
          if (this.categoriaSelecionada != null) {
            categoriaSelecionada = this.categoriaSelecionada.valor;
          }
          let dados = JSON.parse(localStorage.getItem("login"));
          this.token = dados.token;
          let filtros = await axios.post(
            `https://www.leverosintegra.com.br/Map/Api/ProdutoLista?Ciclo=&Tensao=${capacidadeSelecionada}&TipoGas=&Categoria=${categoriaSelecionada}&Marca=${marcaSelecionada}&token=${this.token}`
          );
          let vazia = {
            valor: "",
            id: "",
          };
          this.marcas = [];
          this.categorias = [];
          this.capacidade = [];
          this.marcas.push(vazia);
          this.categorias.push(vazia);
          this.capacidade.push(vazia);
          for (let filtro in filtros.data) {
            if (filtros.data[filtro].id == "Marca") {
              this.marcas.push(filtros.data[filtro]);
            } else if (filtros.data[filtro].id == "Tensao") {
              this.capacidade.push(filtros.data[filtro]);
            } else if (filtros.data[filtro].id == "Categoria") {
              this.categorias.push(filtros.data[filtro]);
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async montaDropDowns() {
			try{
				let salesChannelLV2 = await axios({
					method: 'get',
					url: 'https://leverosintegra.dev.br/api/auth/salesChannel',
					headers: {
							token: '39ba2070-c234-11ec-8d18-f56907899f1a',
					},
				})

				for(let i = 0; i < salesChannelLV2.data.length; i++){
					if(salesChannelLV2.data[i].statusChannel == true){
						this.canais.push({
							valor: salesChannelLV2.data[i].salesChannel,
							id: salesChannelLV2.data[i].salesChannel
						})
					}
				}

				let salesChannelLV1 = await axios({
					method: 'post',
					url: 'https://www.leverosintegra.com.br/map/api/Search?token=',
					data: {
							"Script": "select AFFILIATEID as value, AFFILIATEID as id from salesChannel where ATIVO = 'S' -- row"
					}
				})

				for(let i = 0; i < salesChannelLV1.data.length; i++){
					this.canais.push({
						valor: salesChannelLV1.data[i].VALUE,
						id: salesChannelLV1.data[i].ID
					})
				}

				this.canais = this.canais.sort((a,b) => (a.valor > b.valor) ? 1 : ((b.valor > a.valor) ? -1 : 0))


			} catch (e) {
        console.log(e);
      }
      try {
        let campanhas = await axios.get(
          `https://pricing-api.leverosservicos.com.br/campanhas/get`
        );

        this.result = campanhas.data;
      } catch (e) {
        console.log(e);
      }
      try {
        let dados = JSON.parse(localStorage.getItem("login"));
        this.token = dados.token;
        let marcas = await axios.get(
          `https://www.leverosintegra.com.br/Map/Api/ProdutoLista?tipo=Marca&token=${this.token}`
        );
        let categorias = await axios.get(
          `https://www.leverosintegra.com.br/Map/Api/ProdutoLista?tipo=Categoria&token=${this.token}`
        );
        let capacidades = await axios.get(
          `https://www.leverosintegra.com.br/Map/Api/ProdutoLista?tipo=Capacidade&token=${this.token}`
        );
        let vazia = {
          valor: "",
          id: "",
        };
        this.marcas.push(vazia);
        this.categorias.push(vazia);
        this.capacidade.push(vazia);
        for (let marca in marcas.data) {
          this.marcas.push(marcas.data[marca]);
        }
        for (let categoria in categorias.data) {
          this.categorias.push(categorias.data[categoria]);
        }
        for (let capacidade in capacidades.data) {
          this.capacidade.push(capacidades.data[capacidade]);
        }
      } catch (e) {
        console.log(e);
      }
    },
    reloadPage() {
      window.location.reload();
    },
    async editItem() {},
    async addItem() {},
    deletePrice() {},
  },
  beforeMount() {
    this.montaDropDowns();
  },
};
</script>

<style lang="scss" scoped>
.campanhas {
  max-width: 90%;
  margin: 0 auto;
  padding-top: 40px;

  &__title {
    color: var(--standardGreen);
    font-size: 1.25rem;
    margin-bottom: 40px;
  }

  &__label {
    color: var(--customGray-500);
    font-size: 0.875rem;
  }
}

.campanhasSalvas,
.regrasSelecionadas {
  padding: 40px 0 20px 10px;

  @media (min-width: 441px) {
    padding: 40px 0 20px 25px;
  }

  &__search {
    input {
      border-bottom: 1px solid var(--customGray-200);
      width: 100%;
      outline: none;
      margin-bottom: 10px;
      padding: 5px 0;
      color: var(--customGray-500);
      font-size: 0.95rem;

      @media (min-width: 441px) {
        width: 35%;
      }

      &:focus {
        border-bottom: 2px solid var(--customGray-800);
      }
    }
  }

  &__title {
    color: var(--standardGreen);
    font-size: 1.2rem;
    padding-bottom: 30px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;

    thead {
      tr {
        th {
          background: var(--customGray-100);
          padding: 7px;
          color: var(--standardGreen);
          font-size: 0.95rem;
        }
      }
    }

    tbody {
      tr {
        td {
          text-align: center;
          padding: 10px;
          border-bottom: 1px solid var(--customGray-100);
          color: var(--customGray-500);
          font-size: 0.95rem;
        }
      }
    }
  }

  button {
    background: var(--standardGreen);
    border-radius: 5px;
    color: var(--customWhite);
    padding: 5px;
    margin-top: 25px;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
      0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    letter-spacing: 0.0492857143rem;
    font-size: 0.95rem;
  }
}
</style>
